module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "modal modal-default fade",
    attrs: {
      "id": "modal-show"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header bg-success"
  }, [_vm._m(0), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t('pages.preview')))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('exercise', {
    attrs: {
      "bareBonesExercise": _vm.CelotnaNaloga,
      "showAnswer": true
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer bg-success"
  }, [_c('button', {
    staticClass: "btn btn-default pull-right",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleShowModal()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.exerciseList.hide')))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('section', {
    staticClass: "invoice"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('div', {
    staticClass: "col-xs-1"
  }, [_c('h2', {
    staticClass: "page-header pull-right"
  }, [(!_vm.exam.isExam) ? _c('i', {
    staticClass: "fa fa-hourglass"
  }) : _c('i', {
    staticClass: "fa fa-calendar"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-3",
    class: {
      grayout: _vm.published
    }
  }, [_c('h3', {
    staticClass: "page-header"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.exam.title),
      expression: "exam.title"
    }],
    attrs: {
      "type": "text",
      "name": "title"
    },
    domProps: {
      "value": (_vm.exam.title)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.exam, "title", $event.target.value)
      }, _vm.changeTitle]
    }
  })])]), _vm._v(" "), (_vm.updatedExam && !_vm.published) ? _c('label', {
    staticClass: "pull-right text-green"
  }, [_vm._v(_vm._s(_vm.$t('pages.exams.editExam.updated')))]) : (_vm.published) ? _c('label', {
    staticClass: "pull-right text-red"
  }, [_vm._v(_vm._s(_vm.$t('pages.exams.editExam.unpublishWarning')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row invoice-info"
  }, [_c('div', {
    class: {
      grayout: _vm.published
    }
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [(!_vm.exam.liveTest) ? _c('label', [_vm._v(_vm._s(_vm.$t('pages.exams.editExam.selectType')) + ": ")]) : _vm._e(), _vm._v(" "), (_vm.exam.isExam && !_vm.exam.liveTest) ? _c('div', {
    staticClass: "btn-group",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_c('button', {
    staticClass: "btn btn-sm btn-primary",
    attrs: {
      "type": "button"
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.exams.editExam.exam')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.changeType('quiz')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.exams.editExam.quiz')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.changeType('test')
      }
    }
  }, [_vm._v("Test")])]) : _vm._e(), _vm._v(" "), (!_vm.exam.isExam && !_vm.exam.liveTest) ? _c('div', {
    staticClass: "btn-group",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_c('button', {
    staticClass: "btn btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.changeType('exam')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.exams.editExam.exam')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-primary",
    attrs: {
      "type": "button"
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.exams.editExam.quiz')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.changeType('test')
      }
    }
  }, [_vm._v("Test")])]) : _vm._e(), _vm._v(" "), (!_vm.exam.isExam && _vm.exam.liveTest) ? _c('div', {
    staticClass: "btn-group",
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_c('button', {
    staticClass: "btn btn-sm btn-primary",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("TEST")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [(_vm.exam.showResult) ? _c('div', {
    staticClass: "btn-group",
    staticStyle: {
      "margin-left": "0em"
    }
  }, [_c('button', {
    staticClass: "btn btn-sm btn-primary",
    attrs: {
      "type": "button"
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.exams.editExam.showResults')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.changeShowResult($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.exams.editExam.hideResults')))])]) : _c('div', {
    staticClass: "btn-group",
    staticStyle: {
      "margin-left": "0em"
    }
  }, [_c('button', {
    staticClass: "btn btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.changeShowResult($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.exams.editExam.showResults')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-primary",
    attrs: {
      "type": "button"
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.exams.editExam.hideResults')))])])]), _vm._v(" "), (!_vm.exam.liveTest) ? _c('div', {
    staticClass: "col-sm-5"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('pages.exams.editExam.maxRetries')) + ": ")]), _vm._v(" "), _c('div', {
    staticClass: "radio"
  }, [_c('input', {
    attrs: {
      "type": "radio"
    },
    domProps: {
      "checked": _vm.noLimit
    },
    on: {
      "change": function($event) {
        return _vm.checkLimit(true)
      }
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "for": "one"
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.exams.editExam.noLimit')))])]), _vm._v(" "), _c('div', {
    staticClass: "radio"
  }, [_c('input', {
    attrs: {
      "type": "radio"
    },
    domProps: {
      "checked": !_vm.noLimit
    },
    on: {
      "change": function($event) {
        return _vm.checkLimit(false)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.exam.maxRetries),
      expression: "exam.maxRetries"
    }],
    class: {
      grayout: _vm.noLimit
    },
    attrs: {
      "type": "number",
      "name": "retries",
      "min": "1"
    },
    domProps: {
      "value": (_vm.exam.maxRetries)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.exam, "maxRetries", $event.target.value)
      }, _vm.changeRetries]
    }
  })])]) : _vm._e(), _vm._v(" "), (!_vm.exam.liveTest) ? _c('div', {
    staticClass: "col-sm-7"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('pages.exams.editExam.oneAtATime')) + ": ")]), _vm._v(" "), _c('div', {
    staticClass: "radio"
  }, [_c('input', {
    attrs: {
      "type": "radio"
    },
    domProps: {
      "checked": _vm.oneAtATime
    },
    on: {
      "change": function($event) {
        return _vm.setOneAtATime(true)
      }
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "for": "one"
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.exams.editExam.enabled')))])]), _vm._v(" "), _c('div', {
    staticClass: "radio"
  }, [_c('input', {
    attrs: {
      "type": "radio"
    },
    domProps: {
      "checked": !_vm.oneAtATime
    },
    on: {
      "change": function($event) {
        return _vm.setOneAtATime(false)
      }
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "for": "one"
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.exams.editExam.disabled')))])])]) : _vm._e(), _vm._v(" "), (!_vm.exam.liveTest) ? _c('div', {
    staticClass: "col-sm-5"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('pages.exams.editExam.shuffle')) + ": ")]), _vm._v(" "), _c('div', {
    staticClass: "radio"
  }, [_c('input', {
    attrs: {
      "type": "radio"
    },
    domProps: {
      "checked": _vm.shuffle
    },
    on: {
      "change": function($event) {
        return _vm.setShuffle(true)
      }
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "for": "one"
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.exams.editExam.enabled')))])]), _vm._v(" "), _c('div', {
    staticClass: "radio"
  }, [_c('input', {
    attrs: {
      "type": "radio"
    },
    domProps: {
      "checked": !_vm.shuffle
    },
    on: {
      "change": function($event) {
        return _vm.setShuffle(false)
      }
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "for": "one"
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.exams.editExam.disabled')))])])]) : _vm._e()])]), _vm._v(" "), (!_vm.exam.liveTest) ? _c('div', {
    staticClass: "row"
  }, [_c('h3', {
    staticClass: "page-header"
  }, [_vm._v(_vm._s(_vm.$t('pages.exams.editExam.exercises')))]), _vm._v(" "), _c('div', {
    staticClass: "row margin"
  }, [_c('div', {
    staticClass: "pull-left"
  }, [_c('button', {
    staticClass: "btn btn-default",
    class: {
      grayout: _vm.published
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleExercisesModal()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    class: {
      grayout: _vm.published
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.selectSubgroups()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-bar-chart"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#modal-updateExam"
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.exams.editExam.refreshExercises')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleCollapseParametric($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.collapseParametric ? _vm.$t('pages.exams.editExam.expandParametric') : _vm.$t('pages.exams.editExam.collapseParametric')))])]), _vm._v(" "), (_vm.updated && !_vm.published) ? _c('label', {
    staticClass: "pull-right text-green"
  }, [_vm._v(_vm._s(_vm.$t('pages.exams.editExam.updated')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('table', {
    staticClass: "table table-hover"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("#")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('pages.exams.editExam.tableData')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('pages.exams.editExam.tableTags')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('pages.exams.editExam.tablePoints')))]), _vm._v(" "), (_vm.oneAtATime) ? _c('th', [_vm._v(_vm._s(_vm.$t('pages.exams.editExam.tableTime')))]) : _vm._e()])]), _vm._v(" "), (!_vm.published) ? _c('draggable', {
    attrs: {
      "list": this.combinedExamExercises,
      "element": 'tbody'
    }
  }, _vm._l((this.combinedExamExercises), function(ex, ix) {
    return _c('tr', {
      key: ex.exercise.data.id,
      attrs: {
        "name": "content",
        "rowspan": "3"
      }
    }, [_c('td', {
      staticStyle: {
        "width": "3em"
      }
    }, [_vm._v(_vm._s(ix + 1))]), _vm._v(" "), (ex.exercise.data.id) ? _c('td', {
      staticStyle: {
        "width": "8em"
      },
      attrs: {
        "href": "#"
      }
    }, [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.openModal(ex)
        }
      }
    }, [_vm._v(_vm._s(ex.exercise.data.id))]), _vm._v(" "), (_vm.collapseParametric && ex.parent) ? _c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.showAllExerciseVersions(ex)
        }
      }
    }, [_c('div', {
      staticClass: "badge bg-green"
    }, [_vm._v("(" + _vm._s(_vm.getAllExerciseVersions(ex).length) + " " + _vm._s(_vm.$t('pages.exams.editExam.versions')) + ")")])]) : _vm._e(), _vm._v(" "), (!_vm.collapseParametric && ex.parent) ? _c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.toggleCollapseParametric($event)
        }
      }
    }, [_c('div', {
      staticClass: "badge bg-green"
    }, [_vm._v("(" + _vm._s(_vm.$t('pages.exams.editExam.collapseParametric')) + ")")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('td', {
      attrs: {
        "name": "tags"
      }
    }, _vm._l((ex.exercise.data.tags), function(tag) {
      return _c('span', [_c('div', {
        staticClass: "badge bg-blue"
      }, [_vm._v(_vm._s(tag))])])
    }), 0), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "35em"
      }
    }, [_c('div', [_c('div', _vm._l((ex.scoringSettings), function(set, ix1, ix2) {
      return _c('div', {
        key: ix1,
        staticClass: "row",
        staticStyle: {
          "margin-right": "1em",
          "margin-bottom": "0.125em",
          "border": "0.5px solid",
          "border-radius": "5px",
          "border-color": "rgba(0,0,0,0.2)"
        }
      }, [_c('form', [_c('span', {
        staticStyle: {
          "width": "10em",
          "margin-right": "2em",
          "margin-left": "1em"
        }
      }, [_vm._v("\n                          " + _vm._s(_vm.$t('pages.exams.editExam.question')) + " " + _vm._s(ix2 + 1) + "\n                        ")]), _vm._v(" "), _c('span', {
        staticStyle: {
          "margin-right": "2em"
        }
      }, [_c('i', {
        staticClass: "fa fa-plus-circle",
        staticStyle: {
          "margin-right": "0.25em",
          "color": "#3c8dbc"
        }
      }), _vm._v(" "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (set.posPoints),
          expression: "set.posPoints"
        }],
        attrs: {
          "type": "number",
          "name": "points3",
          "min": "0"
        },
        domProps: {
          "value": (set.posPoints)
        },
        on: {
          "input": [function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(set, "posPoints", $event.target.value)
          }, function($event) {
            return _vm.changePoints(ex, set, false, ix1)
          }]
        }
      })]), _vm._v(" "), _c('span', {
        class: {
          grayout: !set.allowNegativePointsSum
        },
        staticStyle: {
          "margin-right": "1em"
        }
      }, [_c('i', {
        staticClass: "fa fa-minus-circle",
        staticStyle: {
          "margin-right": "0.25em",
          "color": "#3c8dbc"
        }
      }), _vm._v(" "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (set.negPoints),
          expression: "set.negPoints"
        }],
        attrs: {
          "min": "0",
          "step": "1",
          "type": "number",
          "name": "points3"
        },
        domProps: {
          "value": (set.negPoints)
        },
        on: {
          "input": [function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(set, "negPoints", $event.target.value)
          }, function($event) {
            return _vm.changePoints(ex, set, false, ix1)
          }]
        }
      })]), _vm._v(" "), _c('span', {
        attrs: {
          "width": "130"
        }
      }, [_c('a', {
        staticClass: "btn btn-lg allow"
      }, [(!set.allowNegativePointsSum) ? _c('i', {
        staticClass: "fa fa-minus-square-o",
        on: {
          "click": function($event) {
            $event.preventDefault();
            return _vm.changePoints(ex, set, true, ix1)
          }
        }
      }) : _c('i', {
        staticClass: "fa fa-check-square-o",
        on: {
          "click": function($event) {
            $event.preventDefault();
            return _vm.changePoints(ex, set, true, ix1)
          }
        }
      })]), _vm._v(" "), _c('span', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (!set.allowNegativePointsSum),
          expression: "!set.allowNegativePointsSum"
        }],
        staticClass: "small"
      }, [_vm._v(_vm._s(_vm.$t('pages.exams.editExam.notAllowed')))]), _vm._v(" "), _c('span', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (set.allowNegativePointsSum),
          expression: "set.allowNegativePointsSum"
        }],
        staticClass: "small"
      }, [_vm._v(_vm._s(_vm.$t('pages.exams.editExam.allowed')))])])])])
    }), 0)])]), _vm._v(" "), (_vm.oneAtATime) ? _c('td', {
      staticStyle: {
        "width": "3em"
      },
      attrs: {
        "href": "#"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (ex.exerciseSeconds),
        expression: "ex.exerciseSeconds"
      }],
      attrs: {
        "type": "number",
        "min": "1"
      },
      domProps: {
        "value": (ex.exerciseSeconds)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(ex, "exerciseSeconds", $event.target.value)
        }, function($event) {
          return _vm.changeTime(ex)
        }]
      }
    })]) : _vm._e(), _vm._v(" "), _c('td', [_c('a', {
      staticClass: "pull-right btn-sm btn-danger",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.removeRowExercise(ex)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])])])
  }), 0) : (_vm.published && !_vm.exam.liveTest) ? _c('tbody', {
    class: {
      grayout: _vm.published
    }
  }, _vm._l((this.combinedExamExercises), function(ex, ix) {
    return _c('tr', {
      key: ex.exercise.data.id,
      attrs: {
        "name": "content"
      }
    }, [_c('td', {
      staticStyle: {
        "width": "3em"
      }
    }, [_vm._v(_vm._s(ix + 1))]), _vm._v(" "), (ex.exercise.data.id) ? _c('td', {
      staticStyle: {
        "width": "8em"
      }
    }, [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.openModal(ex)
        }
      }
    }, [_vm._v(_vm._s(ex.exercise.data.id))])]) : _vm._e(), _vm._v(" "), _c('td', {
      attrs: {
        "name": "tags"
      }
    }, _vm._l((ex.exercise.data.tags), function(tag) {
      return _c('span', [_c('div', {
        staticClass: "badge bg-blue"
      }, [_vm._v(_vm._s(tag))])])
    }), 0), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "35em"
      }
    }, [_c('div', [_c('div', _vm._l((ex.scoringSettings), function(set, ix1, ix2) {
      return _c('div', {
        key: ix1,
        staticClass: "row",
        staticStyle: {
          "margin-right": "1em",
          "margin-bottom": "0.125em",
          "border": "0.5px solid",
          "border-radius": "5px",
          "border-color": "rgba(0,0,0,0.2)"
        }
      }, [_c('form', [_c('span', {
        staticStyle: {
          "width": "10em",
          "margin-right": "2em",
          "margin-left": "1em"
        }
      }, [_vm._v("\n                          " + _vm._s(_vm.$t('pages.exams.editExam.question')) + " " + _vm._s(ix2 + 1) + "\n                        ")]), _vm._v(" "), _c('span', {
        staticStyle: {
          "margin-right": "2em"
        }
      }, [_c('i', {
        staticClass: "fa fa-plus-circle",
        staticStyle: {
          "margin-right": "0.25em",
          "color": "#3c8dbc"
        }
      }), _vm._v(" "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (set.posPoints),
          expression: "set.posPoints"
        }],
        attrs: {
          "type": "number",
          "name": "points3",
          "min": "0"
        },
        domProps: {
          "value": (set.posPoints)
        },
        on: {
          "input": [function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(set, "posPoints", $event.target.value)
          }, function($event) {
            return _vm.changePoints(ex, set, false)
          }]
        }
      })]), _vm._v(" "), _c('span', {
        class: {
          grayout: !set.allowNegativePointsSum
        },
        staticStyle: {
          "margin-right": "1em"
        }
      }, [_c('i', {
        staticClass: "fa fa-minus-circle",
        staticStyle: {
          "margin-right": "0.25em",
          "color": "#3c8dbc"
        }
      }), _vm._v(" "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (set.negPoints),
          expression: "set.negPoints"
        }],
        attrs: {
          "min": "0",
          "step": "1",
          "type": "number",
          "name": "points3"
        },
        domProps: {
          "value": (set.negPoints)
        },
        on: {
          "input": [function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(set, "negPoints", $event.target.value)
          }, function($event) {
            return _vm.changePoints(ex, set, false)
          }]
        }
      })]), _vm._v(" "), _c('span', {
        attrs: {
          "width": "130"
        }
      }, [_c('a', {
        staticClass: "btn btn-lg allow"
      }, [(!set.allowNegativePointsSum) ? _c('i', {
        staticClass: "fa fa-minus-square-o",
        on: {
          "click": function($event) {
            $event.preventDefault();
            return _vm.changePoints(ex, set, true)
          }
        }
      }) : _c('i', {
        staticClass: "fa fa-check-square-o",
        on: {
          "click": function($event) {
            $event.preventDefault();
            return _vm.changePoints(ex, set, true)
          }
        }
      })]), _vm._v(" "), _c('span', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (!set.allowNegativePointsSum),
          expression: "!set.allowNegativePointsSum"
        }],
        staticClass: "small"
      }, [_vm._v(_vm._s(_vm.$t('pages.exams.editExam.notAllowed')))]), _vm._v(" "), _c('span', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (set.allowNegativePointsSum),
          expression: "set.allowNegativePointsSum"
        }],
        staticClass: "small"
      }, [_vm._v(_vm._s(_vm.$t('pages.exams.editExam.allowed')))])])])])
    }), 0)])]), _vm._v(" "), _c('td', [_c('a', {
      staticClass: "pull-right btn-sm btn-danger",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.removeRowExercise(ex)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])])])
  }), 0) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), (_vm.exam.liveTest) ? _c('div', {
    staticClass: "row"
  }, [_c('table', {
    staticClass: "exerciseGroupsList"
  }, _vm._l((['A', 'B', 'C', 'D']), function(name, index) {
    return _c('tr', {
      key: name,
      staticClass: "exerciseGroupsContainer"
    }, [_c('h4', {
      staticClass: "exerciseGroupsTitle"
    }, [_vm._v("GROUP " + _vm._s(name))]), _vm._v(" "), _c('button', {
      staticClass: "exerciseGroupsAddButton",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.selectGroup(name) + _vm.toggleExercisesModal()
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-plus"
    })]), _vm._v(" "), _c('span', {
      staticStyle: {
        "position": "relative"
      }
    }, [_c('button', {
      staticClass: "exerciseGroupsAddButton dropdown-toggle",
      staticStyle: {
        "margin-left": "1ex"
      },
      attrs: {
        "type": "button",
        "data-toggle": "dropdown"
      }
    }, [_c('i', {
      staticClass: "fa fa-copy"
    }), _vm._v(" " + _vm._s(_vm.$t('pages.exams.editExam.copyExercises')) + "\n            ")]), _vm._v(" "), _c('ul', {
      staticClass: "dropdown-menu"
    }, _vm._l((['A', 'B', 'C', 'D']), function(n, i) {
      return (n !== name) ? _c('li', {
        key: name + '.' + n
      }, [_c('a', {
        on: {
          "click": function($event) {
            return _vm.copyExercises(name, i)
          }
        }
      }, [_vm._v(_vm._s(_vm.$t('pages.exams.editExam.fromGroup')) + " " + _vm._s(n))])]) : _vm._e()
    }), 0)]), _vm._v(" "), _c('button', {
      staticClass: "exerciseGroupsAddButton",
      staticStyle: {
        "margin-left": "1ex"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.selectGroup(name);
          _vm.selectSubgroups()
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-bar-chart"
    }), _vm._v(" " + _vm._s(_vm.$t('pages.exams.editExam.ratingExercises')) + "\n          ")]), _vm._v(" "), _c('div', {
      staticClass: "row margin"
    }, [_c('div', {
      staticClass: "col-xs-12"
    }, [_c('table', {
      staticClass: "table table-hover"
    }, [_c('thead', [_c('tr', [_c('th', [_vm._v("#")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('pages.exams.editExam.tableData')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('pages.exams.editExam.tableTags')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('pages.exams.editExam.tablePoints')))])])]), _vm._v(" "), _c('draggable', {
      attrs: {
        "list": _vm.examExercisesByGroup[index],
        "element": 'tbody'
      }
    }, _vm._l((_vm.examExercisesByGroup[index]), function(ex, ix) {
      return _c('tr', {
        key: index + '.' + ix,
        attrs: {
          "name": "content",
          "rowspan": "3"
        }
      }, [_c('td', {
        staticStyle: {
          "width": "3em"
        }
      }, [_vm._v(_vm._s(ix + 1))]), _vm._v(" "), (ex.exercise.data.id) ? _c('td', {
        staticStyle: {
          "width": "8em"
        },
        attrs: {
          "href": "#"
        }
      }, [_c('a', {
        attrs: {
          "href": "#"
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            return _vm.openModal(ex)
          }
        }
      }, [_vm._v(_vm._s(ex.exercise.data.id))])]) : _vm._e(), _vm._v(" "), _c('td', {
        attrs: {
          "name": "tags"
        }
      }, _vm._l((ex.exercise.data.tags), function(tag) {
        return _c('span', {
          key: index + '.' + ix + '.' + tag
        }, [_c('div', {
          staticClass: "badge bg-blue"
        }, [_vm._v(_vm._s(tag))])])
      }), 0), _vm._v(" "), _c('td', {
        staticStyle: {
          "width": "35em"
        }
      }, [_c('div', [_c('div', _vm._l((ex.scoringSettings), function(set, ix1, ix2) {
        return _c('div', {
          key: index + '-' + ix1,
          staticClass: "row",
          staticStyle: {
            "margin-right": "1em",
            "margin-bottom": "0.125em",
            "border": "0.5px solid",
            "border-radius": "5px",
            "border-color": "rgba(0,0,0,0.2)"
          }
        }, [_c('form', [_c('span', {
          staticStyle: {
            "width": "10em",
            "margin-right": "2em",
            "margin-left": "1em"
          }
        }, [_vm._v("\n                          " + _vm._s(_vm.$t('pages.exams.editExam.question')) + " " + _vm._s(ix2 + 1) + "\n                        ")]), _vm._v(" "), _c('span', {
          staticStyle: {
            "margin-right": "2em"
          }
        }, [_c('i', {
          staticClass: "fa fa-plus-circle",
          staticStyle: {
            "margin-right": "0.25em",
            "color": "#3c8dbc"
          }
        }), _vm._v(" "), _c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (set.posPoints),
            expression: "set.posPoints"
          }],
          attrs: {
            "type": "number",
            "name": "points3",
            "min": "0"
          },
          domProps: {
            "value": (set.posPoints)
          },
          on: {
            "input": [function($event) {
              if ($event.target.composing) { return; }
              _vm.$set(set, "posPoints", $event.target.value)
            }, function($event) {
              return _vm.changePoints(ex, set, false)
            }]
          }
        })]), _vm._v(" "), _c('span', {
          class: {
            grayout: !set.allowNegativePointsSum
          },
          staticStyle: {
            "margin-right": "1em"
          }
        }, [_c('i', {
          staticClass: "fa fa-minus-circle",
          staticStyle: {
            "margin-right": "0.25em",
            "color": "#3c8dbc"
          }
        }), _vm._v(" "), _c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (set.negPoints),
            expression: "set.negPoints"
          }],
          attrs: {
            "min": "0",
            "step": "1",
            "type": "number",
            "name": "points3"
          },
          domProps: {
            "value": (set.negPoints)
          },
          on: {
            "input": [function($event) {
              if ($event.target.composing) { return; }
              _vm.$set(set, "negPoints", $event.target.value)
            }, function($event) {
              return _vm.changePoints(ex, set, false)
            }]
          }
        })]), _vm._v(" "), _c('span', {
          attrs: {
            "width": "130"
          }
        }, [_c('a', {
          staticClass: "btn btn-lg allow"
        }, [(!set.allowNegativePointsSum) ? _c('i', {
          staticClass: "fa fa-minus-square-o",
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.changePoints(ex, set, true)
            }
          }
        }) : _c('i', {
          staticClass: "fa fa-check-square-o",
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.changePoints(ex, set, true)
            }
          }
        })]), _vm._v(" "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (!set.allowNegativePointsSum),
            expression: "!set.allowNegativePointsSum"
          }],
          staticClass: "small"
        }, [_vm._v(_vm._s(_vm.$t('pages.exams.editExam.notAllowed')))]), _vm._v(" "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (set.allowNegativePointsSum),
            expression: "set.allowNegativePointsSum"
          }],
          staticClass: "small"
        }, [_vm._v(_vm._s(_vm.$t('pages.exams.editExam.allowed')))])])])])
      }), 0)])]), _vm._v(" "), _c('td', [_c('a', {
        staticClass: "pull-right btn-sm btn-danger",
        attrs: {
          "href": "#"
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            return _vm.removeExerciseGroup(ex)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-trash"
      })])])])
    }), 0)], 1)])])])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('h3', {
    staticClass: "page-header"
  }, [_vm._v(_vm._s(_vm.$t('pages.exams.editExam.classExams')))]), _vm._v(" "), _c('div', {
    staticClass: "row margin"
  }, [_c('div', {
    staticClass: "btn-group over-border"
  }, [_c('button', {
    staticClass: "btn btn-default dropdown-toggle",
    class: {
      grayout: _vm.published
    },
    attrs: {
      "type": "button",
      "data-toggle": "dropdown",
      "aria-expanded": "true"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu",
    staticStyle: {
      "position": "absolute"
    },
    attrs: {
      "role": "menu"
    }
  }, _vm._l((_vm.classes), function(cl2) {
    return _c('li', [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.createClassExam(cl2)
        }
      }
    }, [_vm._v(_vm._s(cl2.name))])])
  }), 0)]), _vm._v(" "), (_vm.updated2 && !_vm.published) ? _c('label', {
    staticClass: "pull-right text-green"
  }, [_vm._v(_vm._s(_vm.$t('pages.exams.editExam.updated')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 table-responsive"
  }, [_c('table', {
    staticClass: "table table-hover"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('pages.exams.editExam.tableClass')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('pages.exams.editExam.tablePass')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('pages.exams.editExam.tableDateTime')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('pages.exams.editExam.tableDuration')))]), _vm._v(" "), (_vm.exam.isExam == false && _vm.exam.liveTest) ? _c('th', [_vm._v(_vm._s(_vm.$t('pages.exams.editExam.classRoom')))]) : _vm._e()])]), _vm._v(" "), _c('tbody', _vm._l((this.classExams), function(cl, index) {
    return _c('tr', [_c('td', {
      class: {
        grayout: _vm.published
      }
    }, [_vm._v("\n                  " + _vm._s(cl.class.name) + "\n                ")]), _vm._v(" "), _c('td', {
      class: {
        grayout: _vm.published
      }
    }, [(cl.passwordRequired) ? _c('button', {
      staticClass: "btn btn-sm btn-default",
      attrs: {
        "name": "btn-pass"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.changePassModal(cl)
        }
      }
    }, [_vm._v("********")]) : _c('button', {
      staticClass: "btn btn-sm btn-default",
      attrs: {
        "name": "btn-pass"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.changePassModal(cl)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('pages.exams.editExam.passwordNotSet')))])]), _vm._v(" "), _c('td', {
      staticClass: "date-range",
      class: {
        grayout: _vm.published
      }
    }, [_c('div', [_c('date-range-picker', {
      staticClass: "picker",
      attrs: {
        "startDate": cl.startsAt,
        "endDate": cl.finishesAt,
        "nameOfPicker": cl.id
      },
      model: {
        value: (_vm.dateRange),
        callback: function($$v) {
          _vm.dateRange = $$v
        },
        expression: "dateRange"
      }
    })], 1)]), _vm._v(" "), _c('td', {
      staticClass: "duration",
      class: {
        grayout: _vm.published
      }
    }, [_c('div', {
      staticClass: "input-group"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (cl.duration),
        expression: "cl.duration"
      }],
      attrs: {
        "type": "number",
        "name": "points2",
        "min": "0",
        "step": "1"
      },
      domProps: {
        "value": (cl.duration)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(cl, "duration", $event.target.value)
        }, function($event) {
          return _vm.changeDuration(cl, index)
        }]
      }
    }), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selected[index]),
        expression: "selected[index]"
      }],
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.selected, index, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          return _vm.changeDuration(cl, index)
        }]
      }
    }, [_c('option', {
      domProps: {
        "selected": 3
      }
    }, [_vm._v(_vm._s(_vm.$t('pages.exams.editExam.timeMinutes')))]), _vm._v(" "), _c('option', {
      domProps: {
        "selected": 4
      }
    }, [_vm._v(_vm._s(_vm.$t('pages.exams.editExam.timeHours')))]), _vm._v(" "), _c('option', {
      domProps: {
        "selected": 5
      }
    }, [_vm._v(_vm._s(_vm.$t('pages.exams.editExam.timeDays')))])])])]), _vm._v(" "), (_vm.exam.isExam == false && _vm.exam.liveTest) ? _c('td', {
      class: {
        grayout: _vm.published
      }
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (cl.classroom),
        expression: "cl.classroom"
      }],
      staticClass: "classroomDropdown",
      attrs: {
        "name": "classroomSelect"
      },
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(cl, "classroom", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          return _vm.updateClassroom(cl)
        }]
      }
    }, _vm._l((_vm.availableClassrooms), function(classroom) {
      return _c('option', {
        key: classroom.id,
        domProps: {
          "value": classroom.id
        }
      }, [_vm._v(_vm._s(JSON.parse(classroom.classroomInfo).name))])
    }), 0)]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "pull-right"
    }, [_c('div', {
      staticClass: "btn-group"
    }, [(!cl.publishedAt) ? _c('button', {
      staticClass: "btn btn-sm btn-primary",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.publish(cl, true)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('pages.exams.editExam.publish')))]) : _vm._e()]), _vm._v(" "), (!cl.publishedAt) ? _c('button', {
      staticClass: "btn btn-sm btn-danger",
      class: {
        grayout: _vm.published
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.removeRowClass(cl)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })]) : _c('button', {
      staticClass: "btn btn-sm btn-default bg-primary",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.publish(cl, false)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('pages.exams.editExam.unpublish')))])])])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "border-top": "0.1em double #3c8dbc"
    }
  }, [_c('div', {
    staticClass: "pull-left margin"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleDeleteExam($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "pull-right margin"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.exams.editExam.save')))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal modal-default fade",
    attrs: {
      "id": "modal-edit"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._m(1), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t('pages.exams.editExam.modals.changePassword')))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPass),
      expression: "newPass"
    }],
    staticClass: "form-control",
    domProps: {
      "value": (_vm.newPass)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPass = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', [_vm._v(_vm._s(_vm.$t('pages.exams.editExam.modals.noPassword')))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.changePass()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.exams.editExam.modals.update')))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal modal-default",
    attrs: {
      "id": "modal-exercises",
      "data-target": "#modal-exercises"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header bg-primary"
  }, [_vm._m(2), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t('pages.exams.editExam.modals.searchExercises')))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('exercises-search')], 1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer bg-primary"
  }, [_c('button', {
    staticClass: "btn btn-default pull-left",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleExercisesModal()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.exams.editExam.modals.cancel')))]), _vm._v(" "), (_vm.selectedExercises.length > 0) ? _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addExercisesBulk()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.exams.editExam.modals.add')))]) : _c('button', {
    staticClass: "btn btn-default disabled"
  }, [_vm._v(_vm._s(_vm.$t('pages.exams.editExam.modals.add')))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal modal-default fade",
    attrs: {
      "id": "modal-deleteExam"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._m(3), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t('pages.exams.editExam.modals.deleteTitle')))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('button', {
    staticClass: "btn btn-danger pull-right",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.deleteExam($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.exams.editExam.modals.deleteConfirm')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary pull-left",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleDeleteExam($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.exams.editExam.modals.deleteCancel')))]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal modal-default fade",
    attrs: {
      "id": "modal-updateExam"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._m(4), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t('pages.exams.editExam.modals.updateTitle')))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('pages.exams.editExam.modals.updateBody')))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-danger pull-right",
    class: {
      grayout: _vm.classExams.length > 0
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.fetchLatest($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.exams.editExam.modals.confirmFetchLatest')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary pull-left",
    attrs: {
      "data-dismiss": "modal"
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.exams.editExam.modals.deleteCancel')))]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal modal-default fade",
    attrs: {
      "id": "modal-exercise-versions"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._m(5), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t('pages.exams.editExam.exerciseVersions')))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('table', {
    staticClass: "table table-hover"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("#")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('pages.exams.editExam.tableData')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('pages.exams.editExam.tablePoints')))])])]), _vm._v(" "), _vm._l((this.parametricExerciseVersions), function(ex, ix) {
    return _c('tr', {
      key: ex.exercise.data.id + '-parametric',
      attrs: {
        "rowspan": "3"
      }
    }, [_c('td', {
      staticStyle: {
        "width": "3em"
      }
    }, [_vm._v(_vm._s(ix + 1))]), _vm._v(" "), (ex.exercise.data.id) ? _c('td', {
      staticStyle: {
        "width": "8em"
      },
      attrs: {
        "href": "#"
      }
    }, [_c('a', {
      attrs: {
        "href": "#",
        "data-dismiss": "modal"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.openModal(ex)
        }
      }
    }, [_vm._v(_vm._s(ex.exercise.data.id))])]) : _vm._e(), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "35em"
      }
    }, [_c('div', [_c('div', _vm._l((ex.scoringSettings), function(set, ix1, ix2) {
      return _c('div', {
        key: ix1,
        staticClass: "row",
        staticStyle: {
          "margin-right": "1em",
          "margin-bottom": "0.125em",
          "border": "0.5px solid",
          "border-radius": "5px",
          "border-color": "rgba(0,0,0,0.2)"
        }
      }, [_c('form', [_c('span', {
        staticStyle: {
          "width": "10em",
          "margin-right": "2em",
          "margin-left": "1em"
        }
      }, [_vm._v("\n                          " + _vm._s(_vm.$t('pages.exams.editExam.question')) + " " + _vm._s(ix2 + 1) + "\n                        ")]), _vm._v(" "), _c('span', {
        staticStyle: {
          "margin-right": "2em"
        }
      }, [_c('i', {
        staticClass: "fa fa-plus-circle",
        staticStyle: {
          "margin-right": "0.25em",
          "color": "#3c8dbc"
        }
      }), _vm._v(" "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (set.posPoints),
          expression: "set.posPoints"
        }],
        attrs: {
          "type": "number",
          "name": "points3",
          "min": "0"
        },
        domProps: {
          "value": (set.posPoints)
        },
        on: {
          "input": [function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(set, "posPoints", $event.target.value)
          }, function($event) {
            return _vm.changePoints(ex, set, false, ix1, true)
          }]
        }
      })]), _vm._v(" "), _c('span', {
        class: {
          grayout: !set.allowNegativePointsSum
        },
        staticStyle: {
          "margin-right": "1em"
        }
      }, [_c('i', {
        staticClass: "fa fa-minus-circle",
        staticStyle: {
          "margin-right": "0.25em",
          "color": "#3c8dbc"
        }
      }), _vm._v(" "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (set.negPoints),
          expression: "set.negPoints"
        }],
        attrs: {
          "min": "0",
          "step": "1",
          "type": "number",
          "name": "points3"
        },
        domProps: {
          "value": (set.negPoints)
        },
        on: {
          "input": [function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(set, "negPoints", $event.target.value)
          }, function($event) {
            return _vm.changePoints(ex, set, false, ix1, true)
          }]
        }
      })]), _vm._v(" "), _c('span', {
        attrs: {
          "width": "130"
        }
      }, [_c('a', {
        staticClass: "btn btn-lg allow"
      }, [(!set.allowNegativePointsSum) ? _c('i', {
        staticClass: "fa fa-minus-square-o",
        on: {
          "click": function($event) {
            $event.preventDefault();
            return _vm.changePoints(ex, set, true, ix1, true)
          }
        }
      }) : _c('i', {
        staticClass: "fa fa-check-square-o",
        on: {
          "click": function($event) {
            $event.preventDefault();
            return _vm.changePoints(ex, set, true, ix1, true)
          }
        }
      })]), _vm._v(" "), _c('span', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (!set.allowNegativePointsSum),
          expression: "!set.allowNegativePointsSum"
        }],
        staticClass: "small"
      }, [_vm._v(_vm._s(_vm.$t('pages.exams.editExam.notAllowed')))]), _vm._v(" "), _c('span', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (set.allowNegativePointsSum),
          expression: "set.allowNegativePointsSum"
        }],
        staticClass: "small"
      }, [_vm._v(_vm._s(_vm.$t('pages.exams.editExam.allowed')))])])])])
    }), 0)])])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "data-dismiss": "modal"
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.exams.editExam.modals.cancel')))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal modal-default fade",
    attrs: {
      "id": 'selectSubgroupsModal'
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._m(6), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t('pages.subgroups.selectSubgroups')))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [(_vm.loadingSubgroups) ? _c('span', {
    staticStyle: {
      "width": "100%",
      "text-align": "center"
    }
  }, [_c('pulse-loader', {
    attrs: {
      "color": _vm.spinnerColor,
      "size": _vm.spinnerSize
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, _vm._l((_vm.drevoPodskupin), function(podskupina) {
    return _c('div', [_c('div', {
      style: ('margin-left: ' + (2 * podskupina.nivo) + 'em')
    }, [(podskupina.list) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.izbranePodskupine),
        expression: "izbranePodskupine"
      }],
      attrs: {
        "type": "checkbox",
        "id": podskupina.id
      },
      domProps: {
        "value": podskupina.id,
        "checked": Array.isArray(_vm.izbranePodskupine) ? _vm._i(_vm.izbranePodskupine, podskupina.id) > -1 : (_vm.izbranePodskupine)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.izbranePodskupine,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = podskupina.id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.izbranePodskupine = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.izbranePodskupine = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.izbranePodskupine = $$c
          }
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('label', {
      attrs: {
        "for": podskupina.id
      }
    }, [_vm._v(_vm._s(_vm._f("pickTranslation")(podskupina.name)))]), _vm._v(" "), (!podskupina.list) ? _c('span', {
      staticClass: "text-light-blue pointer",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.selectAllSbgroupsInTree(podskupina.id, true)
        }
      }
    }, [_vm._v("(" + _vm._s(_vm.$t('pages.subgroups.addAll')) + ")")]) : _vm._e(), _vm._v(" "), (!podskupina.list) ? _c('span', {
      staticClass: "text-light-blue pointer",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.selectAllSbgroupsInTree(podskupina.id, false)
        }
      }
    }, [_vm._v("(" + _vm._s(_vm.$t('pages.subgroups.removeAll')) + ")")]) : _vm._e()])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('pages.subgroups.selectDuration')))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.izbranoTrajanje),
      expression: "izbranoTrajanje"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.izbranoTrajanje = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "20"
    }
  }, [_vm._v("20 min")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "30"
    }
  }, [_vm._v("30 min")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "45"
    }
  }, [_vm._v("45 min")])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addRatingExercises()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.exams.editExam.addExercises')))])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-88ad359e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-88ad359e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/group/EditExam.vue
// module id = 1463
// module chunks = 1